import {Tag} from 'antd';

export const BookStatusTag = ({book, props}) => {

    let tagColor, tagLabel;
    if (book) {
        tagColor = "#0ea133"
        tagLabel = `Book`;
    } else {
        tagColor = "#8f8f8f";
        tagLabel = `Standard`;
    }

    return <Tag color={tagColor}>{tagLabel}</Tag>
}